import { gql } from '@apollo/client'
import { Banner } from '@farol-ds/react'
import { ARTIFACT_LABELS } from '@jusbrasil-web/docview/core'

import { Summary_DocumentFragment } from './__generated__/summary.graphql'
import styles from './summary.module.scss'

export interface SummaryProps {
  document: Summary_DocumentFragment
}

export function Summary(props: SummaryProps) {
  const { document } = props
  const { authorTextSummary, artifact } = document
  if (!authorTextSummary) return null

  const artifactLabel = ARTIFACT_LABELS[artifact as keyof typeof ARTIFACT_LABELS]
  const label = artifactLabel.singularLabel.toLocaleLowerCase()
  const preposition = artifactLabel.preposition

  return (
    <Banner type="discovery" className={styles.banner}>
      <Banner.Content>
        <Banner.Title>
          Resumo {preposition} {label}
        </Banner.Title>
        <Banner.Description>{authorTextSummary}</Banner.Description>
      </Banner.Content>
    </Banner>
  )
}

Summary.fragments = {
  document: gql`
    fragment Summary_document on Document {
      artifact
      authorTextSummary
    }
  `,
}
